import { css } from '@emotion/core';
import { mobileMq } from '../../utils/commonMqs';

export const productContent = {
  borderRadius: '22px',
  boxShadow: 'none',
  padding: 0,
  paddingTop: '20px',
  paddingBottom: '50px',
  height: '88%',
};

export const productOverlay = {
  padding: 0,
  top: 0,
  height: '100vh',
  position: 'fixed',
};

export const productInnerWrapper = {
  top: 20,
  maxWidth: 480,
  transform: 'translateX(-50%)',
  height: 'calc(100% - 20px)',
  width: '100%',
  paddingLeft: '13px',
  paddingRight: '13px',
};

export const menuHeader = (theme) => css`
  width: 100%;
  padding-left: ${theme.getSpacing(2, 'px')};
  padding-right: ${theme.getSpacing(2, 'px')};
  padding-bottom: ${theme.getSpacing(2, 'px')};
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const menuTitle = (theme) => css`
  font-family: ${theme && theme.getFont('leagueSpartan')};
  font-size: ${theme && theme.getFontSize(1, 'px')};
  color: ${theme && theme.getColor('text')};
  text-transform: uppercase;
`;

export const contentScroll = (theme) => css`
  width: 100%;
  display: block;
  flex-direction: column;
  align-items: center;
  overflow-y: auto;
  ${mobileMq({
    paddingLeft: [
      theme.getSpacing(1, 'px'),
      theme.getSpacing(1.5, 'px'),
      theme.getSpacing(2, 'px'),
    ],
    paddingRight: [
      theme.getSpacing(1, 'px'),
      theme.getSpacing(1.5, 'px'),
      theme.getSpacing(2, 'px'),
    ],
  })}

  &::-webkit-scrollbar {
    -webkit-appearance: none;
  }
  &::-webkit-scrollbar:vertical {
    width: 8px;
  }
  &::-webkit-scrollbar:horizontal {
    height: 8px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.25);
    border-radius: 10px;
    border: 2px solid #ffffff;
  }
  &::-webkit-scrollbar-track {
    border-radius: 10px;
    background-color: #ffffff;
  }
`;

export const container = (theme) => css`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: ${theme.getSpacing(2, 'px')};
`;

export const productInnerCss = {
  overflowY: 'scroll',
  paddingBottom: '50px',
};
